import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import LogoSinsoft from "../../Assets/logo-sinsoft.png";

interface Props {
  loading: boolean;
}

export function Loader({ loading }: Props) {
  return (
    <Backdrop
      open={loading}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 10,
        backdropFilter: "blur(4px)",
        bgcolor: "rgba(15,23,42,0.45)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2.5,
          px: 5,
          py: 4,
          borderRadius: 4,
          bgcolor: "background.paper",
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
        }}
      >
        {/* Logo dentro de um anel girando */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            size={96}
            thickness={2.5}
            sx={{ color: "primary.main" }}
          />
          <Box
            sx={{
              position: "absolute",
              bgcolor: "#fff",
              borderRadius: 2,
              px: 1.25,
              py: 1,
              display: "flex",
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Box
              component="img"
              src={LogoSinsoft}
              alt="Sinsoft Informática"
              sx={{ width: 54, display: "block" }}
            />
          </Box>
        </Box>

        <Typography
          sx={{ fontWeight: 700, color: "text.secondary", letterSpacing: 0.3 }}
        >
          Carregando...
        </Typography>
      </Box>
    </Backdrop>
  );
}
